import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import { STORE_STARTDATE, STORE_START_TIME, STORE_ENDDATE, STORE_END_TIME, RowDataCompleted, STORE_COMPLETEORDERDATA_DATE, STORE_COMPLETEORDERDATA_EXPORT } from 'src/reducers/completeorderfile';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { transformDataforExport } from './manufacturAction';

export const commonDateFormat = (actualDate: Date | null, type: string) => {

    const date = typeof (actualDate) === 'object' ? actualDate : new Date(actualDate);

    if (type === 'date' && date !== null) {

        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const final = [day, month, year].join('/');

        return final;
    } else if (type === 'time' && date !== null) {

        const hours = `0${date.getHours()}`.slice(-2);
        const minutes = `0${date.getMinutes()}`.slice(-2);
        const seconds = `0${date.getSeconds()}`.slice(-2);
        const strTime = `${hours}:${minutes}:${seconds}`;

        return strTime;
    }
    return null;

};

export const getArchiveData = (getDate: string) => {
    return async (
        dispatch: Dispatch<AppState>,
        getState: () => AppState
    ) => {

        const dataParam = {
            frDt: '',
            ftime: '',
            toDt: '',
            ttime: ''
        };
        const today = new Date();
        if (getDate === 'get') {
            dataParam.frDt = commonDateFormat(getState().completeOrder.startDate || today, 'date') || '';
            dataParam.ftime = commonDateFormat(getState().completeOrder.startTime || today, 'time') || '';
            dataParam.toDt = commonDateFormat(getState().completeOrder.endDate || today, 'date') || '';
            dataParam.ttime = commonDateFormat(getState().completeOrder.endTime || today, 'time') || '';
        } else {
            dataParam.frDt = commonDateFormat(today, 'date') || '';
            dataParam.ftime = commonDateFormat(today, 'time') || '';
            dataParam.toDt = commonDateFormat(today, 'date') || '';
            dataParam.ttime = commonDateFormat(today, 'time') || '';

            const startDate = today;
            const startTime = today;
            const endDate = today;
            const endTime = today;

            dispatch({ type: STORE_STARTDATE, startDate } as AnyAction);
            dispatch({ type: STORE_START_TIME, startTime } as AnyAction);
            dispatch({ type: STORE_ENDDATE, endDate } as AnyAction);
            dispatch({ type: STORE_END_TIME, endTime } as AnyAction);
        }

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL
                }getArchiveData?listType=ccmpto2&userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
            data: dataParam,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                sessionid: getState().user.userDetails.s || ''
            }
        }).then(async function (response: AxiosResponse) {

            if (response.data.length === 1) {
                if (response.data[0].orderno !== '') {
                    const completeOrderDataDate: RowDataCompleted[] = response.data;
                    dispatch({ type: STORE_COMPLETEORDERDATA_DATE, completeOrderDataDate } as AnyAction);

                    const completeOrderDataExport = await transformDataforExport(response.data, ['orderdate', 'completedon', 'dueby'], dispatch, getState);
                    dispatch({ type: STORE_COMPLETEORDERDATA_EXPORT, completeOrderDataExport } as AnyAction);
                } else {
                    const completeOrderDataDate: RowDataCompleted[] = [];
                    dispatch({ type: STORE_COMPLETEORDERDATA_DATE, completeOrderDataDate } as AnyAction);

                    const completeOrderDataExport: RowDataCompleted[] = [];
                    dispatch({ type: STORE_COMPLETEORDERDATA_EXPORT, completeOrderDataExport } as AnyAction);
                }
            } else {
                const completeOrderDataDate: RowDataCompleted[] = response.data;
                dispatch({ type: STORE_COMPLETEORDERDATA_DATE, completeOrderDataDate } as AnyAction);

                const completeOrderDataExport = await transformDataforExport(response.data, ['orderdate', 'completedon', 'dueby'], dispatch, getState);
                dispatch({ type: STORE_COMPLETEORDERDATA_EXPORT, completeOrderDataExport } as AnyAction);
            }

        }).catch(function (error: AxiosError) {
            const completeOrderDataDate: RowDataCompleted[] = [];
            dispatch({ type: STORE_COMPLETEORDERDATA_DATE, completeOrderDataDate } as AnyAction);

            const completeOrderDataExport: RowDataCompleted[] = [];
            dispatch({ type: STORE_COMPLETEORDERDATA_EXPORT, completeOrderDataExport } as AnyAction);
        });

    };
};

export const savefromDate = (startDate: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_STARTDATE, startDate } as AnyAction);
    };
};

export const savefromTime = (startTime: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_START_TIME, startTime } as AnyAction);
    };
};

export const savetoDate = (endDate: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_ENDDATE, endDate } as AnyAction);
    };
};

export const savetoTime = (endTime: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_END_TIME, endTime } as AnyAction);
    };
};



// WEBPACK FOOTER //
// ./src/actions/completedOrderDateAction.ts